package com.nonopn.skywatcher.common.app.pages.map.model.forecast

import androidx.compose.ui.graphics.vector.ImageVector

sealed class ForecastLine(
    val icon: ImageVector? = null,
    val suffix: kotlin.String?,
    val graphValue: GraphValue?
) {
    abstract fun hasNext(): Boolean

    class Int(
        icon: ImageVector,
        suffix: kotlin.String,
        val data: kotlin.Int,
        val next: kotlin.Int? = null,
        graphValue: GraphValue? = null
    ) : ForecastLine(icon, suffix, graphValue) {
        override fun hasNext() = null != next
    }

    class String(
        icon: ImageVector? = null,
        suffix: kotlin.String,
        val data: kotlin.String,
        val next: kotlin.String? = null,
        graphValue: GraphValue? = null
    ) : ForecastLine(icon, suffix, graphValue) {
        override fun hasNext() = null != next
    }

    class Float(
        icon: ImageVector,
        suffix: kotlin.String,
        val data: kotlin.Float,
        val next: kotlin.Float? = null,
        graphValue: GraphValue? = null
    ) : ForecastLine(icon, suffix, graphValue) {
        override fun hasNext() = null != next
    }

    class Double(
        icon: ImageVector,
        suffix: kotlin.String,
        val data: kotlin.Double,
        val next: kotlin.Double? = null,
        graphValue: GraphValue? = null
    ) : ForecastLine(icon, suffix, graphValue) {
        override fun hasNext() = null != next
    }
}